<template>
    <b-table
            v-if="data.length > 0"
            :narrowed="true"
            :striped="true"
            ref="table"
            detailed
            detail-key="id"
            default-sort="topic"
            :data="data"
    >
        <template slot-scope="props">
            <b-table-column label="Topic" field="topic" sortable>{{props.row.topic}}</b-table-column>
        </template>

        <template slot="detail" slot-scope="props">
            <div>
                <div>
                    ID: {{props.row.id}}
                </div>
                <div>
                    Topic: {{props.row.topic}}
                </div>
                <div>Property: {{props.row.property}}</div>
                <div>Filters: {{props.row.hftFilters}}</div>
                <b-button type="is-danger" class="is-small" @click="handleDelete(props.row.id)">Delete</b-button>
            </div>
        </template>
    </b-table>
    <p v-else>No topics.</p>
</template>

<script>
  import {mapActions} from 'vuex';
  import BTableColumn from "buefy/src/components/table/TableColumn";
  import BButton from "buefy/src/components/button/Button";

  export default {
    components: {
      BButton,
      BTableColumn
    },
    name: "topic-list",
    props: ['topics', 'deviceId'],
    data() {
      return {};
    },
    computed: {
      data() {
        if (!this.topics) {
          return [];
        }

        return this.topics;
      }
    },
    methods: {
      ...mapActions('devices', ['deleteDeviceTopic']),
      handleDelete(deviceTopicId) {
        if (confirm('Are you sure ?')) {
          this.deleteDeviceTopic({
            id: this.deviceId,
            deviceTopicId: deviceTopicId
          });
        }
      }
    }
  }
</script>

<style scoped>

</style>